import { DeleteOutlined, SettingOutlined } from '@ant-design/icons';
import { Switch } from 'antd';
import classNames from 'classnames';
import React from 'react';

import ConnectionModel from '@mm/state/model/ConnectionModel';
import TagModel from '@mm/state/model/TagModel';
import { useModalActions } from '@mm/state/modules/modalsState/actions';
import { AudienceSimpleSelect } from '@mm/stateful-components';

import { TagsSelector } from '../TagsSelector/TagsSelector';
import styles from './SalesForceIntegrations.module.css';
import { useTags } from './use-tags';

interface Props {
  connection: ConnectionModel;
  facebookPageId: number;
  radioAllContacts: boolean;
  updateWebhook: (
    data: Partial<ConnectionModel>,
    connection: ConnectionModel,
  ) => void;
  deleteWebhook: (connection: ConnectionModel) => void;
}

export const SalesForceConnection = ({
  connection,
  facebookPageId,
  radioAllContacts,
  updateWebhook,
  deleteWebhook,
}: Props) => {
  const { openIntegrationMappingModal } = useModalActions();

  const onTagsUpdate = async (tags: TagModel[]) => {
    if (!tagsValid()) return;
    updateWebhook({ tags: tagsToConnectionTags(tags) }, connection);
  };

  const {
    onTagChange,
    onTagRemove,
    tagsToConnectionTags,
    tags,
    availableTags,
    tagsValid,
    tagsEnabled,
  } = useTags(connection, onTagsUpdate);

  const onDeleteClick = () => {
    deleteWebhook(connection);
  };

  const onSettingsClick = () => {
    openIntegrationMappingModal({ connection });
  };

  return (
    <>
      {!radioAllContacts && (
        <div className={classNames(styles.audience, styles.gridItem)}>
          <div className={styles.audienceSelectContainer}>
            <AudienceSimpleSelect
              className={styles.audienceSelect}
              selectedAudienceId={connection?.audienceId || undefined}
              onChange={audienceId => updateWebhook({ audienceId }, connection)}
            />
          </div>
        </div>
      )}
      {tagsEnabled && (
        <div className={classNames(styles.tags, styles.gridItem)}>
          <TagsSelector
            onChange={onTagChange}
            onTagRemove={onTagRemove}
            fbPageId={facebookPageId}
            availableTags={availableTags}
            tags={tags}
          />
        </div>
      )}
      {!radioAllContacts && (
        <div className={classNames(styles.connectionActions, styles.gridItem)}>
          <Switch
            defaultChecked={connection.active}
            checkedChildren="Sync"
            unCheckedChildren="No"
            className={styles.switch}
            onChange={active => updateWebhook({ active }, connection)}
          />
          <SettingOutlined onClick={onSettingsClick} />
          <DeleteOutlined onClick={onDeleteClick} />
        </div>
      )}
    </>
  );
};
